// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.1.
// Pre-formatted for Stitches — pass directly to loadTheme without runtime formatting.

/*
 * Following tokens have been deprecated in version 1.3.1, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSStitchesFormattedTheme } from '@leagueplatform/genesis-core';

export const trilliumTheme: GDSStitchesFormattedTheme = {
  rem: {
    space: {
      none: '0',
      quarter: '0.2222222222222222rem',
      half: '0.4444444444444444rem',
      threeQuarters: '0.6666666666666666rem',
      one: '0.8888888888888888rem',
      oneAndHalf: '1.3333333333333333rem',
      two: '1.7777777777777777rem',
      twoAndHalf: '2.2222222222222223rem',
      three: '2.6666666666666665rem',
      four: '3.5555555555555554rem',
      five: '4.444444444444445rem',
      eighth: '0.1111111111111111rem',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
      minusQuarter: '-0.2222222222222222rem',
      minusHalf: '-0.4444444444444444rem',
      minusThreeQuarters: '-0.6666666666666666rem',
      minusOne: '-0.8888888888888888rem',
      minusOneAndHalf: '-1.3333333333333333rem',
      minusTwo: '-1.7777777777777777rem',
      minusTwoAndHalf: '-2.2222222222222223rem',
      minusThree: '-2.6666666666666665rem',
      minusFour: '-3.5555555555555554rem',
      minusFive: '-4.444444444444445rem',
      minusEighth: '-0.1111111111111111rem',
    },
    sizes: {
      none: '0',
      quarter: '0.2222222222222222rem',
      half: '0.4444444444444444rem',
      threeQuarters: '0.6666666666666666rem',
      one: '0.8888888888888888rem',
      oneAndHalf: '1.3333333333333333rem',
      two: '1.7777777777777777rem',
      twoAndHalf: '2.2222222222222223rem',
      three: '2.6666666666666665rem',
      four: '3.5555555555555554rem',
      five: '4.444444444444445rem',
      eighth: '0.1111111111111111rem',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
    },
    fontSizes: {
      headingOne: '1.7777777777777777rem',
      headingTwo: '1.5555555555555556rem',
      headingThree: '1.3333333333333333rem',
      headingFour: '1.1111111111111112rem',
      subtitleOne: '1rem',
      subtitleTwo: '0.8888888888888888rem',
      bodyOne: '1rem',
      bodyOneSecondary: '1rem',
      bodyTwo: '0.8888888888888888rem',
      bodyTwoSecondary: '0.8888888888888888rem',
      buttonOne: '1rem',
      buttonTwo: '0.8888888888888888rem',
      label: '0.7777777777777778rem',
      overline: '0.7777777777777778rem',
      caption: '0.7777777777777778rem',
      tab: '0.7777777777777778rem',
    },
    lineHeights: {
      headingOne: '2.2222222222222223rem',
      headingTwo: '2rem',
      headingThree: '1.7777777777777777rem',
      headingFour: '1.5555555555555556rem',
      subtitleOne: '1.5555555555555556rem',
      subtitleTwo: '1.3333333333333333rem',
      bodyOne: '1.5555555555555556rem',
      bodyOneSecondary: '1.5555555555555556rem',
      bodyTwo: '1.3333333333333333rem',
      bodyTwoSecondary: '1.3333333333333333rem',
      buttonOne: '1.5555555555555556rem',
      buttonTwo: '1.3333333333333333rem',
      label: '1.1111111111111112rem',
      overline: '1.1111111111111112rem',
      caption: '1.1111111111111112rem',
      tab: '1.1111111111111112rem',
    },
  },
  px: {
    space: {
      none: '0',
      quarter: '4px',
      half: '8px',
      threeQuarters: '12px',
      one: '16px',
      oneAndHalf: '24px',
      two: '32px',
      twoAndHalf: '40px',
      three: '48px',
      four: '64px',
      five: '80px',
      eighth: '2px',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      bodyOne: '$half',
      bodyOneSecondary: '$half',
      bodyTwo: '$half',
      bodyTwoSecondary: '$half',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
      minusQuarter: '-4px',
      minusHalf: '-8px',
      minusThreeQuarters: '-12px',
      minusOne: '-16px',
      minusOneAndHalf: '-24px',
      minusTwo: '-32px',
      minusTwoAndHalf: '-40px',
      minusThree: '-48px',
      minusFour: '-64px',
      minusFive: '-80px',
      minusEighth: '-2px',
    },
    sizes: {
      none: '0',
      quarter: '4px',
      half: '8px',
      threeQuarters: '12px',
      one: '16px',
      oneAndHalf: '24px',
      two: '32px',
      twoAndHalf: '40px',
      three: '48px',
      four: '64px',
      five: '80px',
      eighth: '2px',
      headingOne: '$none',
      headingTwo: '$none',
      headingThree: '$none',
      headingFour: '$none',
      subtitleOne: '$none',
      subtitleTwo: '$none',
      bodyOne: '$half',
      bodyOneSecondary: '$half',
      bodyTwo: '$half',
      bodyTwoSecondary: '$half',
      buttonOne: '$none',
      buttonTwo: '$none',
      label: '$none',
      overline: '$none',
      caption: '$none',
      tab: '$none',
    },
    fontSizes: {
      headingOne: '32px',
      headingTwo: '28px',
      headingThree: '24px',
      headingFour: '20px',
      subtitleOne: '18px',
      subtitleTwo: '16px',
      bodyOne: '18px',
      bodyOneSecondary: '$bodyOne',
      bodyTwo: '16px',
      bodyTwoSecondary: '$bodyTwo',
      buttonOne: '18px',
      buttonTwo: '16px',
      label: '14px',
      overline: '14px',
      caption: '14px',
      tab: '14px',
    },
    lineHeights: {
      headingOne: '40px',
      headingTwo: '36px',
      headingThree: '32px',
      headingFour: '28px',
      subtitleOne: '28px',
      subtitleTwo: '24px',
      bodyOne: '28px',
      bodyOneSecondary: '$bodyOne',
      bodyTwo: '24px',
      bodyTwoSecondary: '$bodyTwo',
      buttonOne: '28px',
      buttonTwo: '24px',
      label: '20px',
      overline: '20px',
      caption: '20px',
      tab: '20px',
    },
  },
  colors: {
    surfaceBackgroundPrimary: '#FCFCFBFF',
    surfaceBackgroundSecondary: '#FFFFFFFF',
    surfaceBackgroundTertiary: '#F7F3EFFF',
    surfaceCardPrimary: '#FFFFFFFF',
    surfaceCardSecondary: '#FFFFFFFF',
    surfaceCardDisabled: '#D7D7D7FF',
    surfaceScreenHeaderBackground: '#DBEAEBFF',
    surfaceSkeletonShimmerBackground: '#E7E7E7FF',
    surfaceSkeletonShimmerOverlay:
      'linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)',
    onSurfaceTextPrimary: '#24323AFF',
    onSurfaceTextSubdued: '#545454FF',
    onSurfaceTextReversed: '#FFFFFFFF',
    onSurfaceTextCritical: '#C63A39FF',
    onSurfaceTextSuccess: '#507C03FF',
    onSurfaceTextWarning: '#C94F08FF',
    onSurfaceBorderSubdued: '#EDE7E1FF',
    onSurfaceBorderDefault: '#EDE7E1FF',
    onSurfaceBorderCard: '#EDE7E1FF',
    onSurfaceIconPrimary: '#636363FF',
    interactiveActionPrimary: '#004157FF',
    interactiveActionHovered: '#002C41FF',
    interactiveActionPressed: '#00182CFF',
    interactiveActionSubdued: '#666A6BFF',
    interactiveActionDisabled: '#D6D6D6FF',
    interactiveIconDefault: '#FFFFFFFF',
    interactiveIconDisabled: '#666A6BFF',
    interactiveBackgroundDefault: '#FFFFFFFF',
    interactiveBackgroundDisabled: '#E9EFF3FF',
    interactiveBackgroundHovered: '#F5F8FAFF',
    interactiveBackgroundPressed: '#E9EFF3FF',
    interactiveBorderDefault: '#949494FF',
    interactiveBorderHovered: '#24323AFF',
    interactiveBorderDisabled: '#D6D6D6FF',
    interactiveBorderCriticalDefault: '#C63A39FF',
    interactiveFocusInner: '#1A1A1AFF',
    interactiveFocusOuter: '#1A1A1AFF',
    criticalBackgroundSubdued: '#FFE5E5FF',
    criticalBackgroundSecondary: '#FFFFFFFF',
    criticalBorderDefault: '#C63A39FF',
    criticalIcon: '#C63A39FF',
    warningBackgroundSubdued: '#FAE8D6FF',
    warningBackgroundSecondary: '#FFFFFFFF',
    warningBorderDefault: '#C94F08FF',
    warningIcon: '#C94F08FF',
    successBackgroundSubdued: '#F6FCEBFF',
    successBackgroundSecondary: '#FFFFFFFF',
    successBorderDefault: '#507C03FF',
    successIcon: '#507C03FF',
    highlightBackgroundSubdued: '#EDF8FFFF',
    highlightBackgroundSecondary: '#FFFFFFFF',
    highlightBorderDefault: '#2E5CDFFF',
    highlightIcon: '#2E5CDFFF',
    decorativeBrandPrimaryDarkest: '#006A8EFF',
    decorativeBrandPrimaryDark: '#3689A6FF',
    decorativeBrandPrimaryDefault: '#70ACC0FF',
    decorativeBrandPrimaryBright: '#B2D2DDFF',
    decorativeBrandPrimaryBrightest: '#EBF3F6FF',
    decorativeBrandPrimaryPastel: '#F9FCFDFF',
    decorativeBrandSecondaryDarkest: '#004157FF',
    decorativeBrandSecondaryDark: '#36697AFF',
    decorativeBrandSecondaryDefault: '#7095A1FF',
    decorativeBrandSecondaryBright: '#B2C6CDFF',
    decorativeBrandSecondaryBrightest: '#EBF0F2FF',
    decorativeBrandSecondaryPastel: '#F9FBFBFF',
    decorativeBrandTertiaryDarkest: '#A34732FF',
    decorativeBrandTertiaryDark: '#CA633EFF',
    decorativeBrandTertiaryDefault: '#EC8556FF',
    decorativeBrandTertiaryBright: '#F9AE84FF',
    decorativeBrandTertiaryBrightest: '#FFEFE6FF',
    decorativeBrandTertiaryPastel: '#FFFAF8FF',
    primaryBackgroundDefault: '#004157FF',
    primaryBackgroundHovered: '#002C41FF',
    primaryBackgroundPressed: '#00182CFF',
    primaryBackgroundCriticalDefault: '#C63A39FF',
    primaryBackgroundCriticalHovered: '#AD3130FF',
    primaryBackgroundCriticalPressed: '#922928FF',
    primaryTextDefault: '#FFFFFFFF',
    primaryTextCriticalDefault: '#FFFFFFFF',
    secondaryBackgroundDefault: '#FFFFFFFF',
    secondaryBackgroundHovered: '#E9EFF3FF',
    secondaryBackgroundPressed: '#D5DEE3FF',
    secondaryTextDefault: '#004157FF',
    secondaryTextHovered: '#004157FF',
    secondaryBorderDefault: '#004157FF',
    tertiaryBackgroundDefault: '#FFFFFF00',
    tertiaryBackgroundHovered: '#E9EFF3FF',
    tertiaryBackgroundPressed: '#D5DEE3FF',
    tertiaryTextDefault: '#006A8EFF',
    tertiaryTextHovered: '#006A8EFF',
    tertiaryBorderDefault: '#006A8EFF',
    inputBorderSuccess: '#507C03FF',
    inputBorderWarning: '#C94F08FF',
    inputBorderDefault: '#949494FF',
    inputBorderHovered: '#24323AFF',
    inputBorderDisabled: '#D6D6D6FF',
    inputBorderCritical: '#C63A39FF',
    inputBackgroundDefault: '#FFFFFFFF',
    inputBackgroundDisabled: '#E9EFF3FF',
    inputBackgroundHovered: '#F5F8FAFF',
    inputBackgroundPressed: '#E9EFF3FF',
    dataVizInterfaceTrackBorder: '#949494FF',
    dataVizInterfaceTrackBackground: '#F5F5F5FF',
    dataVizSingleColorBrand: '#004157FF',
    dataVizSingleColorNeutral: '#006A8EFF',
    dataVizStatusCritical: '#C63A39FF',
    dataVizStatusWarning: '#C94F08FF',
    dataVizStatusSuccess: '#507C03FF',
    dataVizCategoricalOne: '#006A8EFF',
    dataVizCategoricalTwo: '#70ACC0FF',
    dataVizCategoricalThree: '#004157FF',
    dataVizCategoricalFour: '#7095A1FF',
    dataVizCategoricalFive: '#F9AE84FF',
    dataVizCategoricalSix: '#CA633EFF',
    tagNeutralBackgroundBold: '#49748AFF',
    tagNeutralBackgroundSubdued: '#E9E9E9FF',
    tagNeutralBorderBold: '#49748AFF',
    tagNeutralBorderSubdued: '#E9E9E9FF',
    tagNeutralTextBold: '#FFFFFFFF',
    tagNeutralTextSubdued: '#24323AFF',
    tagOneBackgroundBold: '#006A8EFF',
    tagOneBackgroundSubdued: '#D9E9EEFF',
    tagOneBorderBold: '#006A8EFF',
    tagOneBorderSubdued: '#D9E9EEFF',
    tagOneTextBold: '#FFFFFFFF',
    tagOneTextSubdued: '#24323AFF',
    tagTwoBackgroundBold: '#004157FF',
    tagTwoBackgroundSubdued: '#CCD9DDFF',
    tagTwoBorderBold: '#004157FF',
    tagTwoBorderSubdued: '#CCD9DDFF',
    tagTwoTextBold: '#FFFFFFFF',
    tagTwoTextSubdued: '#24323AFF',
    tagThreeBackgroundBold: '#EDE7E1FF',
    tagThreeBackgroundSubdued: '#EDE7E1FF',
    tagThreeBorderBold: '#EDE7E1FF',
    tagThreeBorderSubdued: '#EDE7E1FF',
    tagThreeTextBold: '#24323AFF',
    tagThreeTextSubdued: '#24323AFF',
    tagFourBackgroundBold: '#F9AE84FF',
    tagFourBackgroundSubdued: '#FBE4D7FF',
    tagFourBorderBold: '#F9AE84FF',
    tagFourBorderSubdued: '#FBE4D7FF',
    tagFourTextBold: '#24323AFF',
    tagFourTextSubdued: '#24323AFF',
    tagSuccessBackgroundBold: '#008A09FF',
    tagSuccessBackgroundSubdued: '#E3F7F0FF',
    tagSuccessBorderBold: '#008A09FF',
    tagSuccessBorderSubdued: '#E3F7F0FF',
    tagSuccessTextBold: '#FFFFFFFF',
    tagSuccessTextSubdued: '#02692BFF',
    tagWarningBackgroundBold: '#B85B0FFF',
    tagWarningBackgroundSubdued: '#FAE8D6FF',
    tagWarningBorderBold: '#B85B0FFF',
    tagWarningBorderSubdued: '#FAE8D6FF',
    tagWarningTextBold: '#FFFFFFFF',
    tagWarningTextSubdued: '#9F3703FF',
    tagCriticalBackgroundBold: '#C63A39FF',
    tagCriticalBackgroundSubdued: '#F9E1E2FF',
    tagCriticalBorderBold: '#C63A39FF',
    tagCriticalBorderSubdued: '#F9E1E2FF',
    tagCriticalTextBold: '#FFFFFFFF',
    tagCriticalTextSubdued: '#AC3332FF',
    tagInformationalBackgroundBold: '#2E5CDFFF',
    tagInformationalBackgroundSubdued: '#E8F8FFFF',
    tagInformationalBorderBold: '#2E5CDFFF',
    tagInformationalBorderSubdued: '#E8F8FFFF',
    tagInformationalTextBold: '#FFFFFFFF',
    tagInformationalTextSubdued: '#225ECEFF',
  },
  fonts: {
    headings:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    headingOne: '$body',
    headingTwo: '$body',
    headingThree: '$body',
    headingFour: '$body',
    subtitleOne: '$body',
    subtitleTwo: '$body',
    bodyOne: '$body',
    bodyOneSecondary: '$body',
    bodyTwo: '$body',
    bodyTwoSecondary: '$body',
    buttonOne: '$body',
    buttonTwo: '$body',
    label: '$body',
    overline: '$body',
    caption: '$body',
    tab: '$body',
  },
  fontWeights: {
    headingOne: 600,
    headingTwo: 600,
    headingThree: 600,
    headingFour: 600,
    subtitleOne: 600,
    subtitleTwo: 600,
    bodyOne: 400,
    bodyOneSecondary: 400,
    bodyTwo: 400,
    bodyTwoSecondary: 400,
    buttonOne: 600,
    buttonTwo: 600,
    label: 400,
    overline: 600,
    caption: 400,
    tab: 400,
  },
  letterSpacings: {
    headingOne: '0',
    headingTwo: '0',
    headingThree: '0',
    headingFour: '0',
    subtitleOne: '-0.20000000298023224px',
    subtitleTwo: '-0.20000000298023224px',
    bodyOne: '0',
    bodyOneSecondary: '$bodyOne',
    bodyTwo: '0',
    bodyTwoSecondary: '$bodyTwo',
    buttonOne: '-0.20000000298023224px',
    buttonTwo: '-0.20000000298023224px',
    label: '0',
    overline: '0.6000000238418579px',
    caption: '0',
    tab: '0',
  },
  textTransforms: {
    headingOne: 'none',
    headingTwo: 'none',
    headingThree: 'none',
    headingFour: 'none',
    subtitleOne: 'none',
    subtitleTwo: 'none',
    bodyOne: 'none',
    bodyOneSecondary: '$bodyOne',
    bodyTwo: 'none',
    bodyTwoSecondary: '$bodyTwo',
    buttonOne: 'none',
    buttonTwo: 'none',
    label: 'none',
    overline: 'uppercase',
    caption: 'none',
    tab: 'none',
  },
  textDecorations: {
    headingOne: 'none',
    headingTwo: 'none',
    headingThree: 'none',
    headingFour: 'none',
    subtitleOne: 'none',
    subtitleTwo: 'none',
    bodyOne: 'none',
    bodyOneSecondary: '$bodyOne',
    bodyTwo: 'none',
    bodyTwoSecondary: '$bodyTwo',
    buttonOne: 'none',
    buttonTwo: 'none',
    label: 'none',
    overline: 'none',
    caption: 'none',
    tab: 'none',
  },
  borderWidths: {
    thin: '1px',
    thick: '2px',
    outerFocus: '3px',
    innerFocus: '3px',
    card: '1px',
  },
  radii: {
    none: '0',
    thin: '1px',
    thick: '2px',
    small: '3px',
    medium: '6px',
    large: '9px',
    extraLarge: '12px',
    huge: '20px',
    circle: '99999px',
    pill: '99999px',
    button: '99999px',
    inputField: '6px',
    card: '6px',
    progressBar: '9999px',
    tags: '4px',
  },
  shadows: {
    card: '0px 0px 0px 0px #00000000',
    dropdown: '0px 4px 8px 0px #0000001A',
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  transitions: { defaultTime: '200ms' },
};
